module.exports = __webpack_public_path__ + "static/media/MaisonNeue-Medium.2a14dd94.woff2";